import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import { authApi } from '../../../Api';
import { LoginSuccessResponse, LoginPayload } from '../../../Types/Auth';

export const login = createAsyncThunk<LoginSuccessResponse, LoginPayload, { rejectValue: any }>(
    'auth/login',
    async (payload, thunkAPI) => {
        try {
            const response = await authApi.login(payload);
            return response.data;
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const axiosError = err as AxiosError<any>;
                if (axiosError.response) return thunkAPI.rejectWithValue(axiosError.response.data);
            }

            // For other types of errors or if there's no response, reject with a generic error.
            return thunkAPI.rejectWithValue({ message: 'An unexpected error occurred.' } as any);
        }
    }
);
